import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';
import RNPickerSelect from 'react-native-picker-select';
import FormError from './FormError';
import FormLabel from './FormLabel';
import Icon from './Icon';

import { Color, CommonProperties } from '../styles';
import { scale } from '../utils/scale.utils';
import { Dropdown } from 'react-native-element-dropdown';

const SelectIcon = Platform.OS === 'web' ? null : <Icon name="chevronDown" size={18} />;

const PickerSelect = (props) => {
  const {
    isLoyalty,
    style,
    placeholder,
    label,
    onValueChange,
    errorMessage,
    required,
    smallText,
    items,
    value,
    useDropdown = false, // Default value set to false if not provided
    ...rest
  } = props;
  return (
    <View style={isLoyalty ? style : [styles.container, style]}>
      {!!label && <FormLabel label={label} required={required} smallText={smallText} />}

      {useDropdown ? (
        <Dropdown
          style={pickerSelectStyles.dropdownStyle}
          placeholderStyle={pickerSelectStyles.placeholder}
          itemTextStyle={pickerSelectStyles.placeholder}
          selectedTextStyle={pickerSelectStyles.placeholder}
          search
          labelField="label"
          valueField="value"
          data={items}
          placeholder={placeholder?.label}
          searchPlaceholder="Search..."
          value={value}
          mode="modal"
          onChange={(selectedValue) => {
            if (selectedValue) {
              onValueChange(selectedValue);
              console.log(selectedValue);
            }
          }}
        />
      ) : (
        <RNPickerSelect
          style={pickerSelectStyles}
          onValueChange={(selectedValue) => {
            if (selectedValue) {
              onValueChange(selectedValue);
            }
          }}
          useNativeAndroidPickerStyle={Platform.OS === 'web'}
          Icon={() => SelectIcon}
          placeholder={{ ...placeholder }}
          items={items}
          value={value}
          {...rest}
        />
      )}

      {!!errorMessage && <FormError errorMessage={errorMessage} />}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    ...CommonProperties.mb4,
  },
});

const commonPickerSelectInputStyle = {
  height: scale(36),
  borderWidth: 1,
  borderColor: Color.gray,
  color: Color.text.high,
  paddingRight: scale(30),
  ...CommonProperties.fontFamily,
  ...CommonProperties.body,
  ...CommonProperties.borderRadius,
  ...CommonProperties.my2,
  ...CommonProperties.px2,
};

const pickerSelectStyles = StyleSheet.create({
  inputWeb: {
    ...commonPickerSelectInputStyle,
    borderWidth: 1,
  },
  inputIOS: {
    ...commonPickerSelectInputStyle,
    borderWidth: 1,
  },
  inputAndroid: {
    ...commonPickerSelectInputStyle,
    borderWidth: 0.5,
  },
  iconContainer: {
    top: 0,
    bottom: 0,
    right: scale(12),
    justifyContent: 'center',
  },
  placeholder: {
    color: Color.black,
    ...CommonProperties.h4,
  },
  dropdownStyle: {
    height: scale(36),
    borderWidth: 1,
    borderColor: Color.gray,
    color: Color.text.high,
    //paddingRight: scale(30),
    ...CommonProperties.fontFamily,
    ...CommonProperties.body,
    ...CommonProperties.borderRadius,
    ...CommonProperties.my2,
    ...CommonProperties.px2,
  },
});
export default PickerSelect;
